export * from './lib/list-notifications/notifications-list.module';
